import {CONSTANTS} from '@/constants'
import { functions } from '@/functions';
import {ServerTable, Event} from 'vue-tables-2'

export const functions_vouchers_view = {

    data: function () {
        return {
            statusFilter:CONSTANTS.VOUCHER_STATE_UNKNOWN,
            rangeCOFilter: null,
            rangeCIFilter: null,
            docCompanyFilter: null,
            companyFilter: null,
            contactsFilter:null,
            userFilter:null,
            activeFilter:false,
            invoiceFilter:false,
            hotelsFilter:null,
            selectedHotel:null,
            clientFilter:null,
            rangeCRFilter:null,
            rangeSCFilter:null,
            overduedFilter:false,
            quotaFilter:false,
            rosturizmFilter:false,

        };
    },
    mixins: [functions],
    components: {
        ServerTable,
    },
    methods: {
        setStatusFilter: function(status) {
            this.statusFilter = status;
            this.saveFilter();
            Event.$emit('vue-tables.filter::status', this.statusFilter);
        },
        applyStatusFilter: function() {
            this.saveFilter();
            Event.$emit('vue-tables.filter::status', this.statusFilter);
        },
        applyCompanyFilter: function()  {
            this.saveFilter();
            Event.$emit('vue-tables.filter::company', this.companyFilter);
        },
        resetCompanyFilter: function() {
            this.companyFilter = null;
            this.saveFilter();
            Event.$emit('vue-tables.filter::company', null);
        },
        applyDocCompanyFilter: function()  {
            this.saveFilter();
            Event.$emit('vue-tables.filter::doccompany', this.docCompanyFilter);
        },
        resetDocCompanyFilter: function() {
            this.docCompanyFilter = null;
            this.saveFilter();
            Event.$emit('vue-tables.filter::doccompany', null);
        },
        applyUserFilter: function() {
            this.saveFilter();
            Event.$emit('vue-tables.filter::user', this.userFilter);
        },
        resetUserFilter: function() {
            this.userFilter = null;
            this.saveFilter();
            Event.$emit('vue-tables.filter::user', null);
        },
        applyHotelFilter: function() {
            console.log('applyHotelFilter');
            if (this.is(this.selectedHotel)) {
                this.hotelFilter = this.selectedHotel.id;
            }
            else {
                this.hotelFilter = null;
            }
            console.log(this.selectedHotel);
            console.log(this.hotelFilter);
            this.saveFilter();
            Event.$emit('vue-tables.filter::hotel', this.hotelFilter);
        },
        resetHotelFilter: function() {
            this.hotelFilter = null;
            this.selectedHotel = null;
            this.saveFilter();
            Event.$emit('vue-tables.filter::hotel', null);
        },
        applyClientFilter: function() {
            this.saveFilter();
            Event.$emit('vue-tables.filter::client', this.clientFilter);
        },
        resetClientFilter: function() {
            this.clientFilter = null;
            this.saveFilter();
            Event.$emit('vue-tables.filter::client', null);
        },

        applyRangeCOFilter: function() {
            this.saveFilter();
            Event.$emit('vue-tables.filter::rangeco', this.rangeCOString);
        },
        resetRangeCOFilter: function() {
            this.rangeCOFilter = null;
            this.saveFilter();
            Event.$emit('vue-tables.filter::rangeco', null);
        },
        applyRangeCIFilter: function() {
            this.saveFilter();
            Event.$emit('vue-tables.filter::rangeci', this.rangeCIString);
        },
        resetRangeCIFilter: function() {
            this.rangeCIFilter = null;
            this.saveFilter();
            Event.$emit('vue-tables.filter::rangeci', null);
        },
        applyRangeCRFilter: function() {
            this.saveFilter();
            Event.$emit('vue-tables.filter::rangecr', this.rangeCRString);
        },
        resetRangeCRFilter: function() {
            this.rangeCRFilter = null;
            this.saveFilter();
            Event.$emit('vue-tables.filter::rangecr', null);
        },
        applyRangeSCFilter: function() {
            this.saveFilter();
            Event.$emit('vue-tables.filter::rangesc', this.rangeSCString);
        },
        resetRangeSCFilter: function() {
            this.rangeSCFilter = null;
            this.saveFilter();
            Event.$emit('vue-tables.filter::rangesc', null);
        },


        applyContactsFilter: function() {
            this.saveFilter();
            Event.$emit('vue-tables.filter::contacts', this.contactsFilter);
        },
        resetContactsFilter: function() {
            this.contactsFilter = null;
            this.saveFilter();
            Event.$emit('vue-tables.filter::contacts', null);
        },

        applyActiveFilter: function() {
            this.saveFilter();
            Event.$emit('vue-tables.filter::active', this.activeFilter);
        },
        resetActiveFilter: function() {
            this.activeFilter = false;
            this.saveFilter();
            Event.$emit('vue-tables.filter::active', false);
        },

        applyInvoiceFilter: function() {
            this.saveFilter();
            Event.$emit('vue-tables.filter::invoice', this.invoiceFilter);
        },
        resetInvoiceFilter: function() {
            this.activeFilter = false;
            this.saveFilter();
            Event.$emit('vue-tables.filter::invoice', false);
        },

        overduedChanged: function() {
            this.saveFilter();
            Event.$emit('vue-tables.filter::overdued', this.overduedFilter);
        },

        quotaChanged: function() {
            this.saveFilter();
            Event.$emit('vue-tables.filter::quota', this.quotaFilter);
        },

        rosturizmChanged: function() {
            this.saveFilter();
            Event.$emit('vue-tables.filter::rosturizm', this.rosturizmFilter);
        },


        vouchersCount(status, companyMode=false, globalMode=false) {
            if (!this.is(this.$store.state)) return 'e1';
            if (!this.is(this.$store.state.status)) return 'e2';
            if (!this.is(this.$store.state.status.vouchers)) return 'e3';
            if (companyMode) {
                if (!this.is(this.$store.state.status.vouchers.cstatuses)) return 'e4';

                if (CONSTANTS.STATUS_GROUPS['k'+status]) {
                    let n=0;
                    for (let s in CONSTANTS.STATUS_GROUPS['k'+status]) {
                        let m = CONSTANTS.STATUS_GROUPS['k'+status][s];
                        if (this.is(this.$store.state.status.vouchers.cstatuses[m])) {
                            n = n + this.$store.state.status.vouchers.cstatuses[m];
                        }
                    }
                    return n;
                }

                if (!this.is(this.$store.state.status.vouchers.cstatuses[status])) return 0;

                return this.$store.state.status.vouchers.cstatuses[status];
            }
            else if (globalMode) {
                if (!this.is(this.$store.state.status.vouchers.gstatuses)) return 'e5';

                if (CONSTANTS.STATUS_GROUPS['k'+status]) {
                    let n=0;
                    for (let s in CONSTANTS.STATUS_GROUPS['k'+status]) {
                        let m = CONSTANTS.STATUS_GROUPS['k'+status][s];
                        if (this.is(this.$store.state.status.vouchers.gstatuses[m])) {
                            n = n + this.$store.state.status.vouchers.gstatuses[m];
                        }
                    }
                    return n;
                }

                if (!this.is(this.$store.state.status.vouchers.gstatuses[status])) return 0;

                return this.$store.state.status.vouchers.gstatuses[status];
            }
            else  {
                if (!this.is(this.$store.state.status.vouchers.statuses)) return 'e6';

                if (CONSTANTS.STATUS_GROUPS['k'+status]) {
                    let n=0;
                    for (let s in CONSTANTS.STATUS_GROUPS['k'+status]) {
                        let m = CONSTANTS.STATUS_GROUPS['k'+status][s];
                        if (this.is(this.$store.state.status.vouchers.statuses[m])) {
                            n = n + this.$store.state.status.vouchers.statuses[m];
                        }
                    }
                    return n;
                }

                if (!this.is(this.$store.state.status.vouchers.statuses[status])) return 0;

                return this.$store.state.status.vouchers.statuses[status];
            }

        },

        getStatusesTV: function(){
            return CONSTANTS.VOUCHER_STATE_NAMES;
        },

        x_date: function (voucher) {
            let res = '';
            if (voucher.status_changed_at) {
                res = printDateTime(voucher.status_changed_at, false, true);
                if (voucher.close_status_at) {
                    res += '<br>';
                    if (this.statusExpired(voucher)) {
                        res += '<span class="status-expired">';
                        res += printDateTime(voucher.close_status_at, false, true);
                        res += '</span>';
                    }
                    else {
                        res += printDateTime(voucher.close_status_at, false, true);
                    }
                }
            }
            return res;
        }

    },
    computed: {
        rangeStart: function () { return new Date(this.rangeCOFilter.start).toLocaleDateString() },
        rangeEnd: function () { return new Date(this.rangeCOFilter.end).toLocaleDateString() },
        rangeString: function () { return rangeString(this.rangeCOFilter); },
        rangeCIString: function () { return rangeString(this.rangeCIFilter); },
        rangeCOString: function () { return rangeString(this.rangeCOFilter); },
        rangeCRString: function () { return rangeString(this.rangeCRFilter); },
        rangeSCString: function () { return rangeString(this.rangeSCFilter); },
    }
};
